import React, { useEffect, useState } from "react";

import {
  QueryClient,
  QueryClientProvider as SDKQueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactQueryDevtools as ReactQueryDevToolsProduction } from "@tanstack/react-query-devtools/production";

declare global {
  interface Window {
    toggleDevtools: () => void;
  }
}

const QueryClientProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [showDevtools, setShowDevtools] = useState(false);

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: Infinity,
            gcTime: Infinity,
            refetchOnWindowFocus: false,
            experimental_prefetchInRender: true,
          },
        },
      }),
  );

  useEffect(() => {
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    <SDKQueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
      {showDevtools && <ReactQueryDevToolsProduction />}
    </SDKQueryClientProvider>
  );
};

export default QueryClientProvider;
